module.exports = __webpack_public_path__ + "img/res5.1a4a6da9.gif";